import type { TabelaPreco } from '../db/tipos'

// Vindo do "+ Produto novo" da tabela (decisao dela 30/09): fornecedora E
// tabela ficam FIXAS -- trocar gravaria o preco na tabela errada. So vale para
// NOVO com os dois parametros; tabela que nao esta viva nesta fornecedora nao
// trava nada (cai no escolhivel de sempre).
export function origemDoCadastro(
  ehNovo: boolean, busca: URLSearchParams, tabelas: TabelaPreco[] | undefined,
): { representadaFixa: string | null; tabelaFixa: TabelaPreco | null } {
  const rep = busca.get('representada'), tabela = busca.get('tabela')
  if (!ehNovo || !rep || !tabela) return { representadaFixa: null, tabelaFixa: null }
  if (tabelas === undefined) return { representadaFixa: rep, tabelaFixa: null }
  const t = tabelas.find((x) => x.id === tabela && x.representada_id === rep && x.ativa && x.apagado_em === null)
  return t ? { representadaFixa: rep, tabelaFixa: t } : { representadaFixa: null, tabelaFixa: null }
}

// A tabela em que o preco sera gravado (revisao final 30/09): a fixa vence; a
// escolhida so vale se estiver entre as tabelas vivas desta fornecedora; tabela
// unica vem escolhida sozinha. Um id morto ou de outra marca nunca liga o campo.
export function tabelaEfetivaDoCadastro(
  tabelaFixa: TabelaPreco | null, escolhida: string, tabelas: TabelaPreco[] | undefined,
): string {
  if (tabelaFixa) return tabelaFixa.id
  if (tabelas?.some((t) => t.id === escolhida)) return escolhida
  return tabelas?.length === 1 ? tabelas[0].id : ''
}
